import React, { ReactNode } from 'react';
import classNames from 'classnames';
import s from './CellAlign.module.less';
import { TCellType } from '../../models';

interface Props {
  children?: ReactNode;
  type?: TCellType;
  className?: string;

  onClick?(e: React.MouseEvent<Element, MouseEvent>): void;
}

export const CellAlign = ({ children, type, className, onClick }: Props) => (
  <span
    className={classNames(className, s.GridCellContent, {
      [s.LeftAlign]: ['string', 'division'].includes(type ?? ''),
      [s.CenterAlign]: type === 'icon',
      [s.RightAlign]: ['date', 'number', 'integer'].includes(type ?? ''),
    })}
    onClick={onClick}
  >
    {children}
  </span>
);
